import React from 'react';
import CoverLetterPanel from '../../../components/CoverLetterPanel';
import { usePreviewContext } from '../providers/PreviewProvider';

export default function CoverLetterCanvas() {
  const {
    authToken,
    resumeData,
    activeVariantId,
    activeCoverLetter,
    coverTemplate,
    accentColor,
    coverLetterReloadTrigger,
  } = usePreviewContext();

  // [TRACE:cl] Bug-CL investigation
  console.log(`[TRACE:cl] CoverLetterCanvas RENDER resumeData.name=${resumeData?.name || 'null'} activeCoverLetter=${activeCoverLetter ? JSON.stringify({id: activeCoverLetter.id, company: activeCoverLetter.company, hasContent: !!activeCoverLetter.content}) : 'null'}`);
  // [TRACE:CL8]
  console.log(`[TRACE:CL8] CoverLetterCanvas body length: ${activeCoverLetter ? (activeCoverLetter.content || '').length : 'n/a'}, rendering body?: ${activeCoverLetter ? (!!activeCoverLetter.content).toString() : 'false'}`);


  return (
    <CoverLetterPanel
      authToken={authToken}
      resumeData={resumeData}
      activeCoverLetterOverride={activeCoverLetter}
      activeVariantId={activeVariantId}
      onCreditsUpdate={() => {}}
      coverTemplate={coverTemplate}
      accentColor={accentColor}
      mode="preview_only"
      coverLetterReloadTrigger={coverLetterReloadTrigger}
    />
  );
}
